import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const displayTexts = document.querySelectorAll('.displayText--inner');

function calculateAnimationWidth(element) {
    const textLength = element.offsetWidth;
    const containerLength = element.parentElement.offsetWidth;
    return (textLength - containerLength) * -1;
}

function createScrollAnimation(element, initialLoad) {
    let animationWidth = calculateAnimationWidth(element);
    let startValue = "bottom 80%";
    let endValue = "top 10%";

    const elementTop = element.getBoundingClientRect().top;
    const elementBottom = element.getBoundingClientRect().bottom;
    const viewportHeight = window.innerHeight;

    if (elementTop >= 0 && elementTop < viewportHeight) {
        startValue = `top ${elementTop}px`;
        endValue = `+=${elementBottom - viewportHeight * 2 / 10}px`;
    }

    return gsap.to(element, {
        x: animationWidth,
        scrollTrigger: {
            trigger: element,
            start: startValue,
            end: endValue,
            scrub: true,
            markers: false,
        }
    });
}

let initialLoad = true;
let windowWidth = window.innerWidth;

displayTexts.forEach((e) => {
    let scrollAnimation = createScrollAnimation(e, initialLoad);
    initialLoad = false;

    const handleResize = debounce(() => {
        if (window.innerWidth !== windowWidth) {
            windowWidth = window.innerWidth;
            gsap.set(e, { x: 0 }); // Reset the element's position
            scrollAnimation.kill(); // Kill the old animation
            scrollAnimation = createScrollAnimation(e, false); // Create a new animation with updated values
            ScrollTrigger.refresh(); // Refresh ScrollTrigger to apply the new values
        }
    }, 150);

    window.addEventListener('resize', handleResize);
});

function debounce(func, wait) {
    let timeout;
    return function() {
        const context = this, args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
    };
}
